export default function YellowAlertActivityFeedIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#FFA200" />
      <g clip-path="url(#clip0_5075_7189)">
        <path
          d="M14 14.6562V10.0625"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.99 6.125H11.01C10.9238 6.12493 10.8384 6.14185 10.7587 6.17479C10.6791 6.20772 10.6067 6.25603 10.5457 6.31695L6.31695 10.5457C6.25603 10.6067 6.20772 10.6791 6.17479 10.7587C6.14185 10.8384 6.12493 10.9238 6.125 11.01V16.99C6.12493 17.0762 6.14185 17.1616 6.17479 17.2413C6.20772 17.321 6.25603 17.3933 6.31695 17.4543L10.5457 21.683C10.6067 21.744 10.6791 21.7923 10.7587 21.8252C10.8384 21.8582 10.9238 21.8751 11.01 21.875H16.99C17.0762 21.8751 17.1616 21.8582 17.2413 21.8252C17.321 21.7923 17.3933 21.744 17.4543 21.683L21.683 17.4543C21.744 17.3933 21.7923 17.321 21.8252 17.2413C21.8582 17.1616 21.8751 17.0762 21.875 16.99V11.01C21.8751 10.9238 21.8582 10.8384 21.8252 10.7587C21.7923 10.6791 21.744 10.6067 21.683 10.5457L17.4543 6.31695C17.3933 6.25603 17.321 6.20772 17.2413 6.17479C17.1616 6.14185 17.0762 6.12493 16.99 6.125Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M14 18.5938C14.5437 18.5938 14.9844 18.153 14.9844 17.6094C14.9844 17.0657 14.5437 16.625 14 16.625C13.4563 16.625 13.0156 17.0657 13.0156 17.6094C13.0156 18.153 13.4563 18.5938 14 18.5938Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5075_7189">
          <rect width="21" height="21" fill="white" transform="translate(3.5 3.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
